import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { clerkPlugin } from '@clerk/vue'
import { dark } from '@clerk/themes'
import router from './router'
import App from './App.vue'
import './style.css'

const app = createApp(App)

app.use(createPinia())

app.use(clerkPlugin, {
  publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  afterSignOutUrl: '/sign-in',
  signInUrl: '/sign-in',
  signUpUrl: '/sign-up',
  appearance: {
    baseTheme: dark,
  },
})

app.use(router)

app.mount('#app')
